import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { SharedComponentsModule } from './shared-components/shared-components.module';

import { AppComponent } from './app.component';
import { ViewsModule } from './views/views.module';

import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';

import { ApiService } from './services/api.service';
import { TranslatesService } from './services/translates.service';
import { ConfigurationService } from './services/configuration.service';
import { QuestionsService } from './services/questions.service';

import { HttpClientModule } from '@angular/common/http';
import { GeoLocationService } from './services/geo-location.service';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { Http, Response } from '@angular/http';

import { HaversineService } from 'ng2-haversine';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ViewsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBGExw5TaTnor4Lf7gVnGZU-5J7LGN1Hq4',
    }),
    AgmDirectionModule,
    SharedComponentsModule,
    DeviceDetectorModule.forRoot()
  ],
  providers: [
      ApiService,
      GeoLocationService,
      ConfigurationService,
      QuestionsService,
      HaversineService,
      QuestionsService,
      TranslatesService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/app.module.ts